import { mapFieldsToSchema } from "./schemaBuilder";

export const siteDataSchema = {
  name: { label: "Site Name", type: "text", initialValue: "", required: true },
  location: {
    label: "Location",
    type: "text",
    initialValue: "",
    required: true,
  },
};

export const gatewaysSchema = {
  name: {
    label: "Gateway Name",
    type: "text",
    initialValue: "",
    required: true,
  },
  queue: {
    label: "Queue ID",
    type: "select", // changed to dropdown
    initialValue: "",
    required: true,
    options: [], // will be populated dynamically
  },
  macAddress: {
    label: "MAC Address",
    type: "text",
    initialValue: "",
    required: true,
  },
  manufacturer: {
    label: "Manufacturer",
    type: "text",
    initialValue: "",
    required: false,
  },
  model: { label: "Model", type: "text", initialValue: "", required: false },
};

export const digitalTagsSchema = {
  name: { label: "Tag Name", type: "text", initialValue: "", required: true },

  macAddress: {
    label: "MAC Address",
    type: "text",
    initialValue: "",
    required: true,
  },
 
  rotation: {
    label: "rotation",
    type: "select", // changed to dropdown
    initialValue: "",
    required: false,
    options: [{ value: "180", label: "180°" }],
  },
};

export const softGatewaysSchema = {
  name: {
    label: "Name",
    type: "text",
    initialValue: "",
    required: true,
  },
  queue: {
    label: "Queue URL",
    type: "select",
    initialValue: "",
    required: true,
    options: [],
  },
  macAddress: {
    label: "Android ID",
    type: "scan",
    initialValue: "",
    required: true,
  },
};

export const dataRecordSchema = (fields = {}, includeLabels = false) => {
  const schema = {};
  schema.identifier = {
    label: "Unique Identifier",
    type: "string",
    initialValue: "",
    required: true,
  };
  const fieldsArray = Array.isArray(fields)
    ? fields
    : Object.keys(fields).map((key) => ({
        name: key.trim(),
        value: fields[key],
        label: key.trim(),
        type: typeof fields[key] === "string" ? "text" : "string",
      }));

  fieldsArray.forEach((field) => {
    schema[field.name] = {
      label: field.label || field.name,
      type: field.type || "text",
      initialValue: field.value || "",
      required: false,
    };
  });

  if (includeLabels) {
    schema.labels = {
      label: "Labels",
      type: "multiselect-icons",
      required: false,
    };
  }

  return schema;
};

export function buildDataInfoSchema(name, fields) {
  return {
    name,
    fields: mapFieldsToSchema(fields),
  };
}
export function mapUserFieldsToApiFields(userFields) {
  return userFields.reduce((acc, field) => {
    if (!field.name) return acc;
    acc[field.name] = Array.isArray(field.value)
      ? field.value
      : field.value || "";
    return acc;
  }, {});
}
